import { acceptHMRUpdate, defineStore } from 'pinia'

import { useLayoutStore } from '~/store/layout'

export const useScrollStore = defineStore('scroll', {
  state: () => ({
    initialized: false,
    orientation: 'vertical',
    x: 0,
    y: 0,
    percent: 0,
    direction: null,
    locked: false,
    isScrolling: false,
    limit: 0
  }),
  getters: {
    getHeaderScrolled: state => state.orientation === 'vertical' ? state.y > 90 : state.x > 90,
    getFirstHalfViewportScrolled: state => state.orientation === 'vertical' ? state.y > (useLayoutStore().height / 1.5) : state.x > (useLayoutStore().width / 1.5),
    getFirstViewportScrolled: state => state.orientation === 'vertical' ? state.y > useLayoutStore().height : state.x > useLayoutStore().width,
    getDirection: state => state.direction ?? 'down',
    getLimit: state => state.limit ?? 0,
    safeZoneScrolled: state => {
      const layout = useLayoutStore()
      return state.y > (layout.height - 60)
    },
    footerZone: state => {
      const layout = useLayoutStore()
      return !!state.limit ? (state.y >= (state.limit - (layout.height / 2))) : false
    }
  },
  actions: {
    resetPosition () {
      this.x = 0
      this.y = 0
      this.percent = 0
    },
    setData (payload) {
      this.isScrolling = payload.isScrolling
      this.limit = payload.limit
      this.x = payload.x
      this.y = payload.y

      if (this.orientation === 'vertical') {
        this.direction = payload.direction === 1 ? 'down' : 'up'
      } else {
        this.direction = payload.direction === 1 ? 'right' : 'left'
      }

      if ([ 'down', 'up' ].includes(this.direction)) {
        this.percent = Math.round((payload.y / payload.limit) * 100)
      } else {
        this.percent = Math.round((payload.x / payload.limit) * 100)
      }
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useScrollStore, import.meta.hot))
}
